import React from 'react';
import { fmtEuro } from './reparationsUtils';

export function availableAvoirs(avoirs = []) {
  return (avoirs || []).filter(
    (a) => Number(a.solde) > 0.001 && a.statut !== 'annule' && a.statut !== 'utilise',
  );
}

/** RESTE : jamais « Soldé » s’il existe un avoir utilisable — impression + PDF. */
export default function RepairResteDisplay({ reste, avoirs, onPrintAvoir, onDownloadAvoirPdf, className = '' }) {
  const list = availableAvoirs(avoirs);
  if (list.length > 0) {
    const first = list[0];
    return (
      <div className={className} data-testid="reste-avoir-disponible">
        <button
          type="button"
          onClick={() => onPrintAvoir?.(first.ref)}
          className="text-sm font-bold text-emerald-400 underline underline-offset-2 hover:text-emerald-300"
          title={`Imprimer ${first.ref}`}
        >
          Avoir disponible
        </button>
        <button
          type="button"
          onClick={() => onDownloadAvoirPdf?.(first.ref)}
          className="block w-full mt-0.5 text-[10px] font-semibold text-emerald-300/80 underline underline-offset-2 hover:text-emerald-200"
          title={`Télécharger ${first.ref}.pdf`}
          data-testid="reste-avoir-pdf"
        >
          Télécharger PDF
        </button>
        {Number(reste) > 0.01 && (
          <div className="text-[11px] text-red-400 mt-0.5 tabular-nums">{fmtEuro(reste)} €</div>
        )}
      </div>
    );
  }
  return Number(reste) > 0
    ? `${fmtEuro(reste)} €`
    : 'Soldé';
}
